import _JSXStyle from "styled-jsx/style";
import PropTypes from 'prop-types';
import React, { Children, cloneElement, isValidElement } from 'react';

const Menu = _ref => {
  let {
    children,
    className,
    dataTest,
    dense
  } = _ref;
  return /*#__PURE__*/React.createElement("ul", {
    "data-test": dataTest,
    className: "jsx-3549878755" + " " + (className || "")
  }, Children.map(children, (child, index) => /*#__PURE__*/isValidElement(child) ? /*#__PURE__*/cloneElement(child, {
    dense: typeof child.props.dense === 'boolean' ? child.props.dense : dense,
    hideDivider: typeof child.props.hideDivider !== 'boolean' && index === 0 ? true : child.props.hideDivider
  }) : child), /*#__PURE__*/React.createElement(_JSXStyle, {
    id: "3549878755"
  }, ["ul.jsx-3549878755{display:block;position:relative;width:100%;margin:0;padding:0;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;}"]));
};

Menu.defaultProps = {
  dataTest: 'dhis2-uicore-menulist'
};
Menu.propTypes = {
  /** Typically `MenuItem`, `MenuDivider`, and `MenuSectionHeader` */
  children: PropTypes.node,
  className: PropTypes.string,
  dataTest: PropTypes.string,

  /** Applies `dense` property to all child components unless already specified */
  dense: PropTypes.bool
};
export { Menu };